<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5" style="min-width: 300px;">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Вход в кабинет клиента</v-toolbar-title>
            <v-spacer></v-spacer>
            
          </v-toolbar>
          <v-card-text>
            <v-form v-model="isValid" ref="authForm">
              <v-alert 
                dense 
                outlined
                type="error" 
                :value="Boolean(serverError)"
                transition="scale-transition"
              >
                {{ serverError }}
              </v-alert>
              <v-text-field
                v-model="phoneNumber"
                v-mask="'##########'"
                label="Номер телефона"
                prepend-icon="mdi-phone"
                filled
                :prefix="phonePrefix"
                @focus="phonePrefix = '+7';serverError = ''"
                @blur="phoneNumber || (phonePrefix = '')"
                :rules="[v => v.length == 10 || 'Введите корректный номер моб. телефона.']"
                :disabled="showCode"
              ></v-text-field>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-if="showCode"
                v-model="code"
                v-mask="'######'"
                label="Код подтверждения"
                prepend-icon="mdi-lock"
                filled
                :rules="[v => v.length == 6 || 'Введите 6-значный код из SMS.']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <template v-if="!showCode">
              <v-spacer></v-spacer>
              <v-btn 
                color="primary" 
                @click="serverError = false; sendSms()"
                :disabled="loadingLoginSendSms"
                :loading="loadingLoginSendSms"
                class="mb-3"
              >Получить код</v-btn>
              <v-spacer></v-spacer>
            </template>
            <template v-else>
              <v-spacer></v-spacer>
              <v-btn
                @click="cancel()"
                :disabled="loadingLoginCheckCode"
                :loading="loadingLoginCheckCode"
                class="mb-3 mr-3"
              >Изменить номер</v-btn>
              <v-btn
                color="primary"
                @click="checkCode()"
                :disabled="loadingLoginCheckCode"
                :loading="loadingLoginCheckCode"
                class="mb-3 mr-2"
              >Войти</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import validator from 'validator';
import { log } from 'util';

export default {
  data() {
    return {
      isValid: false,

      phonePrefix: '',
      phoneNumber: '',
      code: '',
      showPassword: false,
      showCode: false,
      
      serverError: '',
    }
  },
  
  created() {
    document.title = 'Авторизация';
  },

  methods: {
    async sendSms() {
      this.$refs.authForm.validate();
      if (this.isValid) {
        try {
          await this.$store.dispatch('loginSendSms', this.phoneNumber);
          this.showCode = true;
        } catch(err) {
          this.serverError = err.message;
        }
      }
    },

    async checkCode() {
      this.$refs.authForm.validate();
      if (this.isValid) {
        try {
          await this.$store.dispatch('loginCheckCode', {
            phoneNumber: this.phoneNumber,
            code: this.code
          });
          this.$router.push('/');
        } catch(err) {
          this.code = '';
          this.showCode = false;
          this.serverError = err.message;
        }
      }
    },

    async cancel() {
      this.code = '';
      this.showCode = false;
      this.serverError = err.message;
    }
  },

  computed: {
    ...mapGetters(['loadingLoginSendSms', 'loadingLoginCheckCode'])
  },
}
</script>